import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";
import { HomepageHeaderArenaBadgeDefaultBox } from "./home-page-header-arena-badge.default.box";
import { HomepageHeaderArenaBadgeSIBox } from "./home-page-header-arena-badge.si.box";
import { HomepageHeaderArenaBadgeMrGreenBox } from "./home-page-header-arena-badge.mrgreen.box";

export const HomepageHeaderArenaBadgeBox = styledByTheme(HomepageHeaderArenaBadgeDefaultBox)
    .forSI(HomepageHeaderArenaBadgeSIBox)
    .forMrGreen(HomepageHeaderArenaBadgeMrGreenBox).apply();
